/**
 * Homepage slider script
 */
class Bookero_HomepageSlider {
  constructor (wrapper) {
    this.sliderWrapper = wrapper;  
    this.initState();
    this.initEvents();
  }

  initState() { 
    this.dots = this.sliderWrapper.find('.dot');
    this.nextBtn = this.sliderWrapper.find('.next');
    this.list = this.sliderWrapper.find('.slider-list');
    this.items = this.list.find('.slider-item');
    this.currentItem = 0;
    this.animationInProgress = false;
  }

  initEvents() {
    setTimeout(() => {
        this.showNextSlide();
    }, 4500);

    this.swipeEffect = new Hammer(this.sliderWrapper[0]);
    
    this.nextBtn.on('click', e => {
        e.preventDefault();

        if (e.originalEvent) {
            this.blankSlide = true;
        }

        if (this.animationInProgress) {
            return;
        }

        this.currentItem++;
        this.animationInProgress = true;

        if (this.currentItem >= this.items.length) {
            this.currentItem = 0;
        }

        this.dots.removeClass('is-active');
        this.dots.eq(this.currentItem).addClass('is-active');
        this.list.css('margin-left', (-100 * this.currentItem) + "%");

        setTimeout(() => {
            this.animationInProgress = false;
        }, 550);
    });

    for (let i = 0; i < this.dots.length; i++) {
        this.dots.eq(i).on('click', e => {
            e.preventDefault();

            if (e.originalEvent) {
                this.blankSlide = true;
            }

            if (this.animationInProgress) {
                return;
            }

            this.currentItem = i;
            this.animationInProgress = true;
            this.dots.removeClass('is-active');
            this.dots.eq(this.currentItem).addClass('is-active');
            this.list.css('margin-left', (-100 * this.currentItem) + "%");
            
            setTimeout(() => {
                this.animationInProgress = false;
            }, 550);
        });
    }

    this.swipeEffect.on('swipe', ev => {
        if (ev.type === 'swipe' && ev.direction === 2) {
            if (this.currentItem < this.dots.length - 1) {
                this.currentItem++;
            } else {
                this.currentItem = 0;
            }

            this.dots.eq(this.currentItem).trigger('click');
        }

        if (ev.type === 'swipe' && ev.direction === 4) {
            if (this.currentItem > 0) {
                this.currentItem--;
            } else {
                this.currentItem = this.dots.length - 1;
            }

            this.dots.eq(this.currentItem).trigger('click');
        }
    });  
  }

  showNextSlide () {
      if (this.blankSlide) {
          this.blankSlide = false;
      } else {
          this.nextBtn.trigger('click');
      }

      setTimeout(() => {
          this.showNextSlide();
      }, 5500);
  }
}